import { useEffect, useState } from "react";
import "./AgentRun.scss";
import { TabPanel, TabView } from "primereact/tabview";
import { Button } from "primereact/button";
import FlowConfig from "./FlowConfig/FlowConfig";
import AgentConfig from "./AgentConfig/AgentConfig";
import * as XLSX from "xlsx";
import { IAgentWorkflow } from "../../../../../../models/AgentRuntime.model";
import { Utils } from "../../../../../../utils/Utils";
import CodeEditor from "../../../../../shared/widgets/CodeEditor/CodeEditor";
import { fetchTextFile } from "../../../../../../utils/fetchFiles";
import FileExplorer from "../../../../../shared/widgets/FileExplorer/FileExplorer";
import MarkedRender from "../../../../../shared/widgets/MarkedRender/MarkedRender";
import { FaArrowLeftLong } from "react-icons/fa6";
// import { FakeData } from "../../../../../../fakeStorage/FakeData";
// import { IAgent } from "../../../../../../models/Agent.model";
// import AgentToolsDialog from "../AgentTools/AgentTools";
// import { FakeAgentRuntime } from "../../../../../../fakeStorage/teams/AgentRuntime";

interface AgentRunProps {
  selectedWorkflow: string;
  workflows: IAgentWorkflow[];
  handleUpdateRun: any;
  handleBack: any;
}

export default function AgentRun({
  selectedWorkflow,
  workflows,
  handleUpdateRun,
  handleBack,
}: AgentRunProps) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeFileContent, setActiveFileContent] = useState("");
  const [activeFile, setActiveFile] = useState("");
  const [language, setLanguage] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAgentConfig, setIsAgentConfig] = useState(false);
  // const [agentToolDialogOpened, setAgentToolDialogOpened] = useState(false);
  const [config, setConfig] = useState({
    maxIteration: 3,
    threshold: 80,
    analysis: true,
    code_gen: true,
    review: true,
  });
  // const [activeAgentTools, setActiveAgentTools] = useState<string[]>([]);
  // const agents: IAgent[] = FakeData.FakeAgents;

  const handleActiveFile = async (path: string) => {
    const response = await fetchTextFile(path);
    let fileType = "text";
    const splitedPath = path.split(".");
    const lang = splitedPath[splitedPath.length - 1];
    const paths = path.split("/");
    const fileName = paths[paths.length - 1];
    if (lang === "zip") {
      fetch(path)
        // check to make sure you didn't have an unexpected failure (may need to check other things here depending on use case / backend)
        .then((resp) =>
          resp.status === 200
            ? resp.blob()
            : Promise.reject("something went wrong"),
        )
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          // the filename you want
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => console.log("error"));
      setActiveFileContent("");
      return;
    }
    switch (lang) {
      case "md":
        setLanguage("markdown");
        break;
      case "feature":
        setLanguage("gherkin");
        break;
      case "proto":
        setLanguage("javascript");
        break;
      case "spkgb":
        setLanguage("sql");
        break;
      case "cs":
        setLanguage("java");
        break;
      case "xlsx":
        setLanguage("json");
        fileType = "xlsx";
        break;
      case "txt":
        setLanguage("text");
        break;

      default:
        setLanguage(lang);
        break;
    }
    if (fileType === "text") {
      const file = await response.text();
      setIsLoaded(false);
      setActiveFileContent(file);
      setTimeout(() => {
        setIsLoaded(true);
      }, 10);
    } else {
      const arrayBuffer = await response.arrayBuffer();
      const data = new Uint8Array(arrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      setActiveFileContent(JSON.stringify(json, null, 2));
    }
    setActiveFile(path);
  };

  // const handleAgentTools = useCallback(
  //   (tabName: string) => {
  //     const selectedAgent = agents.find((item) => item.name === tabName);
  //     if (selectedAgent) {
  //       if (selectedAgent && selectedAgent?.agentFormData?.tools.length > 0) {
  //         setActiveAgentTools(selectedAgent?.agentFormData?.tools);
  //       } else {
  //         setActiveAgentTools([]);
  //       }
  //     } else {
  //       setActiveAgentTools([]);
  //     }
  //   },
  //   [agents]
  // );

  useEffect(() => {
    const activePath = workflows[0].activeFilePath;
    if (activePath) {
      handleActiveFile(activePath);
    }
    // handleAgentTools(workflows[0].tabName || "");
  }, [workflows]);

  const handleTabChange = (index: number) => {
    // if (workflows[index]) {
    //   handleAgentTools(workflows[index].tabName || "");
    // }
    if (activeIndex === workflows.length - 2) {
      handleUpdateRun({
        tokensUsed: Utils.getRandomNumber(5000, 6000).toString(),
        score: Utils.getRandomNumber(70, 100),
      });
    }
    if (activeIndex === workflows.length - 1) {
      handleBack();
    } else {
      setActiveIndex(index);
      const activePath = workflows[index].activeFilePath;
      if (activePath) {
        handleActiveFile(activePath);
      }
    }
  };

  return (
    <div className="agent-run">
      <div className="agent-form">
        <div className="header-title">
          <Button rounded className="default" onClick={() => handleBack()}>
            <FaArrowLeftLong />
          </Button>
          <h2>{selectedWorkflow}</h2>
        </div>
        <Button
          label="Config"
          severity="secondary"
          outlined
          onClick={() => setIsAgentConfig(true)}
        />
      </div>

      <div className="runtime-layout">
        <div className="tab-section">
          <TabView
            activeIndex={activeIndex}
            onTabChange={(e) => handleTabChange(e.index)}
          >
            {workflows.map((item: any, i) => {
              return (
                <TabPanel key={i} header={item.tabName}>
                  <div className="tab-content">
                    <div className="explorer-section">
                      <FileExplorer
                        activeFile={activeFile}
                        handleActiveFile={handleActiveFile}
                        fileStructure={item?.fileStructure || []}
                      />
                    </div>
                    <div className="editor-section">
                      {/* <div className="view-tool-btn">
                        {activeAgentTools.length > 0 && (
                          <Button
                            className="default"
                            label="View Tool"
                            onClick={() => setAgentToolDialogOpened(true)}
                          />
                        )}
                      </div> */}
                      {language === "markdown"
                        ? isLoaded && (
                            <MarkedRender message={activeFileContent} />
                          )
                        : activeFileContent && (
                            <CodeEditor
                              lang={language}
                              handleChange={() => {}}
                              code={activeFileContent}
                            />
                          )}
                    </div>
                    <div className="continue-action">
                      <Button
                        className="primary"
                        label={`${activeIndex === workflows.length - 1 ? "Finish" : "Continue"}`}
                        onClick={() => handleTabChange(activeIndex + 1)}
                      />
                    </div>
                  </div>
                </TabPanel>
              );
            })}
          </TabView>
        </div>
        <div className="workflow-section">
          <h4>{selectedWorkflow} Flow</h4>
          <div className="reactflow-section">
            {workflows && (
              <FlowConfig workflows={workflows} activeIndex={activeIndex} />
            )}
          </div>
        </div>
      </div>
      {/* {agentToolDialogOpened && (
        <AgentToolsDialog
          agentName={workflows[activeIndex].tabName}
          workflows={activeAgentTools.map((toolName: string, i) => {
            return { ...FakeAgentRuntime[0].workflow[i], tabName: toolName };
          })}
          setAgentToolDialogOpened={setAgentToolDialogOpened}
        />
      )} */}
      {isAgentConfig && (
        <AgentConfig
          setIsAgentConfig={setIsAgentConfig}
          config={config}
          setConfig={setConfig}
        />
      )}
    </div>
  );
}
